import { buildInitialState as buildInitialDateRangeState } from '@components/Kendo/DateRangePickerReducer';
import { translate } from '@utils/i18n';
import LinkTableCell from '@components/Kendo/LinkTableCell';
import ActionsCell from './nested/ActionsCell';
import TimeEntryIdCell from './nested/TimeEntryIdCell';

export const CACHE_KEY = 'kendo/time_entries/index';

export const NAMESPACE = 'features.time_entries.index';

export const INITIAL_PAGE_SKIP = 0;

export const INITIAL_PAGE = { skip: INITIAL_PAGE_SKIP, take: 25 };

export const INITIAL_SORT = [
  {
    field: 'id',
    dir: 'desc'
  }
];

export const INITIAL_FILTERS = {
  values: {
    trackedObjectId: '',
    trackedObjectType: '',
    technician: [],
    visitType: [],
    building: [],
    technicianTeam: [],
    territory: [],
    timeZone: [],
    ...buildInitialDateRangeState('date')
  },
  active: {
    trackedObjectId: false,
    trackedObjectType: false,
    technician: true,
    visitType: true,
    building: true,
    technicianTeam: true,
    territory: true,
    date: true,
    timeZone: false
  },
  operators: {}
};

export const ALL_COLUMNS = [
  'id',
  'technicianName',
  'startDate',
  'startTime',
  'endTime',
  'duration',
  'timeZone',
  'trackedObjectType',
  'rate',
  'buildingName',
  'actions'
];

export const ALL_COLUMNS_DATA = {
  selected: {
    id: 'selected',
    field: 'selected',
    sortable: false,
    title: translate('table.headers.selected', { namespace: NAMESPACE }),
    width: 64,
    className: 'k-table-td --selector',
    headerClassName: 'k-table-th --selector'
  },
  id: {
    id: 'id',
    field: 'id',
    width: 120,
    title: translate('table.headers.id', { namespace: NAMESPACE }),
    className: 'k-table-td --primary',
    headerClassName: 'k-table-th --primary',
    cell: TimeEntryIdCell
  },
  technicianName: {
    id: 'technicianName',
    field: 'technicianName',
    title: translate('table.headers.technician_name', { namespace: NAMESPACE }),
    width: 150,
    cell: LinkTableCell
  },
  startDate: {
    id: 'startDate',
    field: 'startDate',
    width: 120,
    title: translate('table.headers.start_date', { namespace: NAMESPACE })
  },
  startTime: {
    id: 'startTime',
    field: 'startTime',
    width: 120,
    title: translate('table.headers.start_time', { namespace: NAMESPACE }),
    sortable: false
  },
  endTime: {
    id: 'endTime',
    field: 'endTime',
    width: 120,
    title: translate('table.headers.end_time', { namespace: NAMESPACE }),
    sortable: false
  },
  duration: {
    id: 'duration',
    field: 'duration',
    width: 120,
    title: translate('table.headers.duration', { namespace: NAMESPACE }),
    sortable: false
  },
  timeZone: {
    id: 'timeZone',
    field: 'timeZone',
    width: 175,
    title: translate('table.headers.time_zone', { namespace: NAMESPACE }),
    sortable: false
  },
  trackedObjectType: {
    id: 'trackedObjectType',
    field: 'trackedObjectType',
    width: 250,
    title: translate('table.headers.tracked_object_type', { namespace: NAMESPACE }),
    cell: LinkTableCell
  },
  rate: {
    id: 'rate',
    field: 'rate',
    width: 200,
    title: translate('table.headers.rate', { namespace: NAMESPACE }),
    sortable: false
  },
  buildingName: {
    id: 'buildingName',
    field: 'buildingName',
    title: translate('table.headers.building_name', { namespace: NAMESPACE }),
    sortable: false,
    width: 250,
    cell: LinkTableCell
  },
  actions: {
    id: 'actions',
    field: 'actions',
    width: 100,
    title: translate('table.headers.actions', { namespace: NAMESPACE }),
    sortable: false,
    cell: ActionsCell
  }
};
